export const TRANSLATE_NAMESPACE = 'user-account-menu';

export default {
  TRANSLATE_NAMESPACE,
};
